function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.81155 3.46677L0 13.2783L2.56511 15.8434L12.3767 6.03188L9.81155 3.46677Z",
  fill: "#282828"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.377 25.6547L14.9417 28.2204L22.1888 20.9732L29.4351 28.2204L31.9998 25.6547L22.1888 15.8438L12.377 25.6547Z",
  fill: "#282828"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3774 6.0322L22.189 15.8438L24.7541 13.2786L14.9425 3.46709L12.3774 6.0322Z",
  fill: "#282828"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M-2.55731e-05 18.4091L9.81152 28.2207L12.3766 25.6556L2.56509 15.844L-2.55731e-05 18.4091Z",
  fill: "#282828"
});

function SvgAlvaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlvaLogo);
export default __webpack_public_path__ + "static/media/alvaLogo.4633308b6937e643ce7afe0ad0eafc19.svg";
export { ForwardRef as ReactComponent };